<script setup>
import { computed } from 'vue'
import { secondsToDuration } from "@/utils/date.js";
const props = defineProps({
  seconds: {
    type: [Number, String],
    default: null,
  },
})

const durationString = computed(() => {
  if (props.seconds) {
    return secondsToDuration(props.seconds)
  }
  return 0;
})
</script>
<template>
  <span>{{ durationString }}</span>
</template>